import { Injectable } from "@angular/core";
import { Acumatica } from "../acumatica-field-decorator";
import { AcumaticaEntity, AcumaticaEntityService } from "./acumatica-entity";
import { AcumaticaRequestOptions, AcumaticaService } from "../acumatica.service";
import { Observable } from "rxjs";
import { NotFoundError } from "../acumatica-errors";

@Injectable({
    providedIn: 'root'
})
export class CountryService extends AcumaticaEntityService {
    constructor(
        acumatica: AcumaticaService,
    ) {
        super(acumatica, 'Countries', Country);
    }

    getStates(CountryID: string, options: AcumaticaRequestOptions = {}): Observable<Country> {
        options = options || {};
        options.expand = 'States';

        return new Observable<Country>(subscriber => {

            super.getEntity(CountryID, {
                ...{ loader: "Getting Country & States" },
                ...options
            }).subscribe((country: Country) => {
                country.States?.forEach(state => {
                    delete (state.__id);
                    delete (state.__rowNumber);
                });
                subscriber.next(country);
                subscriber.complete();
            },
                error => subscriber.error(error));
        });

    }

    getCountries(options?: AcumaticaRequestOptions): Observable<Country[]> {
        return new Observable<Country[]>(subscriber => {
            super.getEntities<Country>(undefined, options).subscribe(
                countries => {
                    countries.forEach(country => {
                        delete (country.__id);
                        delete (country.__rowNumber);
                    });
                    countries.sort((a, b) => {
                        if (a.ID == 'US') return -1; if (b.ID == 'US') return 1;
                        if (a.ID == 'CA') return -1; if (b.ID == 'CA') return 1;
                        if (a.ID == 'MX') return -1; if (b.ID == 'MX') return 1;
                        if (a.ID == 'PR') return -1; if (b.ID == 'PR') return 1;
                        return a.ID.localeCompare(b.ID);
                    });
                    subscriber.next(countries);
                    subscriber.complete();
                },
                error => {
                    subscriber.error(error);
                    subscriber.complete();
                });
        });
    }
}

export class State extends AcumaticaEntity {
    @Acumatica('StateID') ID!: string;
    @Acumatica('StateName') Name!: string;

    public toString(): string { return this.ID + ' - ' + this.Name; }
}

export class Country extends AcumaticaEntity {
    @Acumatica('CountryID') ID!: string;
    @Acumatica('CountryName') Name!: string;
    @Acumatica(State) States?: State[];

    constructor(init?: Partial<Country>) {
        super();
        if (init) Object.assign(this, init);
    }

    public toString(): string { return this.ID + ' - ' + this.Name; }
}